import type React from 'react';
import { Box, Breadcrumbs, Button, RiMapPinLine } from '@itandi/itandi-bb-ui';
import cx from 'clsx';
import type { ComponentProps } from 'react';
import Styles from './DealLayoutHeader.module.scss';
import type { Deal } from '~/models/Deal';
import { DealTypeLabel } from '~/components/common/parts/label/DealTypeLabel';
import { ClientRelateDealsButton } from '~/components/common/layouts/deals/relate_deals/ClientRelateDealsButton';
import { MEDIA_QUERY, useMediaQuery } from '~/hooks/useMediaQuery';
import { SimpleHeaderClientSP } from '~/components/common/layouts/deals/simple_header/SimpleHeaderClientSP';
import { PATH as RELATED_DEAL_NEW_PATH } from '~/pages/deals/[id]/related_deals/new';

type Props = {
  deal: Deal;
  items: ComponentProps<
    typeof Breadcrumbs | typeof SimpleHeaderClientSP
  >['items'];
  useSimpleSpHeader: boolean;
};

export const DealLayoutHeaderClient: React.FC<Props> = ({
  deal,
  items,
  useSimpleSpHeader
}: Props) => {
  const { match: isSp } = useMediaQuery(MEDIA_QUERY.sp);
  const handleAddRelatedDealClick = (): void => {
    const href = RELATED_DEAL_NEW_PATH(deal.id);
    window.open(href, '_blank');
  };
  return (
    <>
      {useSimpleSpHeader && isSp ? (
        <SimpleHeaderClientSP deal={deal} items={items} />
      ) : (
        <div className={Styles.DealHeader} id="deal_header">
          <div className={Styles.HeaderLeftContent}>
            <Box marginBottom={16}>
              <Breadcrumbs items={items} />
            </Box>
            <div className={Styles.HeaderElements}>
              <div className={Styles.AlignCenter}>
                <DealTypeLabel
                  dealSubtype={deal.dealSubtype}
                  dealType={deal.dealType}
                />
              </div>
              <div>
                <h1 className={Styles.RoomName}>
                  {deal.name} {deal.roomNumber}
                </h1>
              </div>
              <div className={cx(Styles.AlignCenter, Styles.DealAddress)}>
                <RiMapPinLine className={Styles.Icon} />
                {deal.address}
              </div>
            </div>
          </div>
          <div className={Styles.HeaderRightContent}>
            <ClientRelateDealsButton />
            <Button onClick={handleAddRelatedDealClick}>
              関連する案件追加
            </Button>
          </div>
        </div>
      )}
    </>
  );
};
